<template>
  <el-carousel trigger="click" :height="carouselHeight">
    <el-carousel-item
      v-for="(group, index) in partners"
      :key="index"
      :autoplay="false"
    >
      <el-row :gutter="20" class="partners">
        <el-col
          :xs="12"
          :sm="12"
          :md="4"
          :lg="4"
          :xl="4"
          class="partner"
          v-for="(item, i) in group"
          :key="`{index}-${i}`"
        >
          <img :src="`${baseUrl}${item['img']}`" alt="" />
        </el-col>
      </el-row>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "inside"
    }
  },
  data() {
    return {
      group: 0,
      partners: [],
      inside: [
        [
          {
            name: "蒙草",
            img: "mc.png"
          },
          {
            name: "鄂尔多斯市政亿能源有限公司",
            img: "eeds-resource.png"
          },
          {
            name: "呼和浩特市第一医院",
            img: "hhht-hospital.jpg"
          },
          {
            name: "金河生物科技股份有限公司",
            img: "jinhe.png"
          },
          {
            name: "满世投资集团有限公司",
            img: "msjt.png"
          },
          {
            name: "蒙牛乳业（集团）股份有限公司",
            img: "mengniu.png"
          }
        ],
        [
          {
            name: "内蒙古包钢钢联股份有限公司",
            img: "bggf.png"
          },
          {
            name: "内蒙古北方重工业集团有限公司",
            img: "nmg-zgy.jpg"
          },
          {
            name: "内蒙古北方重型汽车股份有限公司",
            img: "nmg-car.png"
          },
          {
            name: "内蒙古第一机械集团股份有限公司",
            img: "nmg-jx.jpg"
          },
          // {
          //   name: "内蒙古第一机械集团股份有限公司",
          //   img: "nmg-jx-gf.jpg"
          // },
          // {
          //   name: "内蒙古第一机械集团有限公司",
          //   img: "nmg-jx.jpg"
          // },
          {
            name: "内蒙古电力（集团）有限责任公司",
            img: "nmg-dl.gif"
          },
          {
            name: "内蒙古鄂尔多斯服装有限公司",
            img: "nmg-fz.png"
          }
        ],
        [
          {
            name: "内蒙古鄂尔多斯羊绒集团有限责任公司",
            img: "eeds-yr.jpg"
          },
          // {
          //   name: "内蒙古鄂尔多斯资源股份有限公司",
          //   img: "eeds-gf.jpg"
          // },
          {
            name: "内蒙古高等级公路建设开发有限责任公司",
            // img: "nmggs.png"
            img: "nmggs_reverse.png"
          },
          {
            name: "内蒙古公路交通投资发展有限公司",
            img: "nmg-road.png"
          },
          {
            name: "内蒙古国有资本运营有限公司",
            img: "nmggy.png"
          },
          {
            name: "内蒙古环保投资集团有限公司",
            img: "nmghb.png"
          },
          {
            name: "内蒙古汇能煤电集团有限公司",
            img: "hnjt.png"
          }
        ],
        [
          {
            name: "内蒙古交通投资（集团）有限责任公司",
            img: "nmg-road-ny.jpg"
          },
          {
            name: "内蒙古蒙电华能热电股份有限公司",
            img: "nmhd.png"
          },
          {
            name: "内蒙古蒙泰煤电集团有限公司",
            img: "mtjt.png"
          },
          {
            name: "内蒙古水务投资集团有限公司",
            img: "nmgsw.png"
          },
          {
            name: "内蒙古伊利实业集团股份有限公司",
            img: "yl.png"
          },
          {
            name: "内蒙古伊泰呼准铁路有限公司",
            img: "ytzd.png"
          }
        ],
        [
          {
            name: "内蒙古伊泰集团有限公司",
            img: "ytjt.png"
          },
          {
            name: "内蒙古伊泰煤炭股份有限公司",
            img: "ytmt.png"
          },
          {
            name: "内蒙古伊泰煤制油有限责任公司",
            img: "ytmy.png"
          },
          {
            name: "内蒙古伊泰宁能精细化工有限公司",
            img: "ytnn.png"
          },
          {
            name: "内蒙古远兴能源股份有限公司",
            img: "yxny.png"
          },
          {
            name: "内蒙古自治区人民医院",
            img: "zzyy.jpg"
          }
        ],
        [
          {
            name: "中国北方稀土集团高科技股份有限公司",
            img: "re.png"
          },
          {
            name: "中国电信股份有限公司内蒙古分公司",
            img: "zgdx.png"
          },
          // {
          //   name: "中国电信集团有限公司内蒙古分公司",
          //   img: "zgdxjt.png"
          // },
          {
            name: "中国航天科工六院",
            img: "zght.png"
          },
          {
            name: "中国联合网络通信有限公司内蒙古自治区分公司",
            img: "zglt.png"
          },
          {
            name: "赤峰学院附属医院",
            img: "cfxyfy.png"
          },
          {
            name: "中国医药集团有限公司",
            img: "gy.png"
          }
        ],
        [
          {
            name: "中国石油天然气股份有限公司内蒙古销售分公司",
            img: "cnpc.png"
          }
        ]
      ],
      outside: [
        [
          {
            name: "烽火通信科技股份有限公司",
            img: "fiberhome.png"
          },
          {
            name: "广州白云电器设备股份有限公司",
            img: "bye.png"
          },
          {
            name: "贵州广播电视台",
            img: "gzgb.png"
          },
          {
            name: "国家电力投资集团有限公司",
            img: "spic.png"
          },
          {
            name: "国家电网有限公司",
            img: "gjdw.png"
          },
          {
            name: "华润(集团)有限公司",
            img: "hr_reverse.png"
          }
        ],
        [
          {
            name: "京东方科技集团股份有限公司",
            img: "boe.png"
          },
          {
            name: "青岛港国际股份有限公司",
            img: "qdgj.png"
          },
          // {
          //   name: "上海电气集团股份有限公司",
          //   // img: "shdq.png"
          //   img: "shdq_reverse.png"
          // },
          {
            name: "四川广播电视台",
            img: "srt.png"
          },
          {
            name: "重庆化医控股(集团)公司",
            img: "cqhy.png"
          },
          {
            name: "中国兵器工业集团有限公司",
            img: "bqgy.png"
          },
          {
            name: "中国兵器装备集团有限公司",
            img: "bqzb.png"
          }
        ],
        [
          {
            name: "中国船舶工业集团有限公司",
            img: "cssc_reverse.png"
          },
          // {
          //   name: "中国船舶重工集团有限公司",
          //   img: "中国船舶重工集团有限公司.png"
          // },
          {
            name: "中国大唐集团有限公司",
            img: "dtjt.png"
          },
          {
            name: "中国电力建设集团有限公司",
            img: "zgdj.png"
          },
          {
            name: "中国电信股份有限公司",
            img: "zgdx.png"
          },
          {
            name: "中国电子科技集团有限公司",
            img: "cetc.png"
          },
          {
            name: "中国电子信息产业集团有限公司",
            img: "cec.png"
          }
        ],
        [
          {
            name: "中国国电集团有限公司",
            img: "chnenergy.png"
          },
          {
            name: "中国海洋石油集团有限公司",
            img: "cnooc.png"
          },
          {
            name: "中国航空发动机集团有限公司",
            img: "zghkfdj.png"
          },
          {
            name: "中国航空工业集团有限公司",
            img: "zghkjt.png"
          },
          {
            name: "中国航天科工集团有限公司",
            img: "cosic.png"
          },
          {
            name: "中国航天科技集团有限公司",
            img: "zghakj.png"
          }
        ],
        [
          {
            name: "中国华电集团有限公司",
            img: "zghd.png"
          },
          {
            name: "中国化工集团有限公司",
            img: "zh.png"
          },
          {
            name: "中国机械工业集团有限公司",
            img: "gjjt.png"
          },
          {
            name: "中国交通建设集团有限公司",
            // img: "zgjj.png",
            img: "zgjj_reverse.png"
          },
          // {
          //   name: "中国林业集团有限公司",
          //   img: "zgly.png"
          // },
          {
            name: "重庆川仪自动化股份有限公司",
            img: "cy.png"
          },
          {
            name: "中国南方电网有限责任公司",
            img: "nfdw.png"
          }
        ],
        [
          {
            name: "中国能源建设集团有限公司",
            img: "ceec.png"
          },
          {
            name: "中国石油化工集团有限公司",
            img: "smodec.png"
          },
          {
            name: "中国石油天然气集团有限公司",
            img: "cnpc.png"
          },
          {
            name: "中国铁建股份有限公司",
            img: "crcc.png"
          },
          {
            name: "中国铁路通信信号股份有限公司",
            img: "crsc.png"
          },
          {
            name: "中国铁路总公司",
            img: "zgtl.png"
          }
        ],
        [
          {
            name: "中国通信服务股份有限公司",
            img: "co.png"
          },
          {
            name: "中国冶金科工股份有限公司",
            img: "mcc.png"
          },
          {
            name: "中国医药集团有限公司",
            img: "gy.png"
          },
          {
            name: "中国移动通信集团有限公司",
            img: "zgyd.png"
          },
          {
            name: "中国长江三峡集团有限公司",
            img: "zgsx.png"
          },
          {
            name: "中国中车股份有限公司",
            img: "crrc.png"
          }
        ],
        [
          {
            name: "中国中煤能源股份有限公司",
            img: "zm.png"
          },
          {
            name: "中国中铁股份有限公司",
            img: "zt.png"
          },
          {
            name: "中信重工机械股份有限公司",
            img: "chi.png"
          }
        ]
      ],
      guangdong: [
        [
          {
            name: "广东广播电视台",
            img: "gb.png"
          },
          {
            name: "广东省能源集团有限公司",
            img: "nyjt.png"
          },
          {
            name: "广州白云电器设备股份有限公司",
            img: "bye.png"
          },
          {
            name: "中国宝武钢铁集团有限公司",
            img: "baowu.png"
          },
          {
            name: "中国兵器工业集团有限公司",
            img: "bqgy.png"
          },
          {
            name: "中国兵器装备集团有限公司",
            img: "bqzb.png"
          }
        ],
        [
          {
            name: "中国船舶工业集团有限公司",
            img: "cssc.png"
          },
          {
            name: "中国电信股份有限公司",
            img: "dx.png"
          },
          {
            name: "中国电子科技集团有限公司",
            img: "cetc.png"
          },
          {
            name: "中国电子信息产业集团有限公司",
            img: "cec.png"
          },
          {
            name: "中国海洋石油集团有限公司",
            img: "cnooc.png"
          },
          {
            name: "中国航空工业集团有限公司",
            img: "avic.png"
          }
        ],
        [
          {
            name: "中国航天科工集团有限公司",
            img: "cosic.png"
          },
          {
            name: "中国航天科技集团有限公司",
            img: "casc.png"
          },
          {
            name: "中国机械工业集团有限公司",
            img: "cetc.png"
          },
          {
            name: "中国电子信息产业集团有限公司",
            img: "cinomrch.png"
          },
          {
            name: "中国交通建设集团有限公司",
            img: "zgjj.png"
          },
          {
            name: "中国联合网络通信有限公司广东省分公司",
            img: "unicom.png"
          }
        ],
        [
          {
            name: "中国南方电网有限责任公司",
            img: "spg.png"
          },
          {
            name: "中国能源建设集团有限公司",
            img: "ceec.png"
          },
          {
            name: "中国石油天然气集团有限公司",
            img: "cnpc.png"
          },
          {
            name: "中国铁建股份有限公司",
            img: "tj.png"
          },
          {
            name: "中国通信服务股份有限公司",
            img: "comservice.png"
          },
          {
            name: "中国医药集团有限公司",
            img: "sinopharm.png"
          }
        ],
        [
          {
            name: "中国中铁股份有限公司",
            img: "rgl.png"
          },
        ],

      ],
      show: false
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    baseUrl() {
      let type = "outside";

      switch (this.type) {
        case "outside1":
          type = "outside";
          break;
        case "inside":
          type = "inside";
          break;
        case "guangdong":
          type = "guangdong";
          break;
      }

      return `${process.env.BASE_URL || "./"}file/partners/${type}/`;
    },
    carouselHeight() {
      return this.isMobile ? "300px" : "160px";
    }
  },
  watch: {
    type: {
      immediate: true,
      handler() {
        this.partners = this[this.type];
      }
    }
  },

  created() {
    this.partners = this[this.type];
    // this.group = Math.ceil(this.inside.length / 5);
    // for (let i = 0; i < this.group; i++) {
    //
    //   let arr = [];
    //   for (let j = 0; j < 5; j++) {
    //     arr.push(this.inside[i*5+j]);
    //   }
    //   this.partners.push(arr);
    // }
    //
    // this.show = true;
    // console.log(this.partners)
  },
  methods: {
    getUrl(name) {
      // return `background: url("${this.baseUrl}${name}") no-repeat center center; background-size: contain;`;
      return {
        background: `url(${this.baseUrl}${name}) no-repeat center center`,
        "background-size": "contain"
      };
    }
  }
};
</script>

<style lang="scss">
.partners {
  display: flex;
  flex-wrap: wrap;
  /*justify-content: space-between;*/

  .partner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    /*width: 20%;*/
    height: 80px;
    background-size: contain;
    box-sizing: border-box;

    &:nth-of-type(4n) {
      margin-left: 0;
    }

    img {
      max-width: 90%;
      max-height: 80%;
    }
  }
}

.el-carousel {
  .el-carousel__button {
    width: 24px;
    background: $high;
  }

  .el-carousel__indicators {
    width: 100%;
    text-align: center;
  }
}

/*.el-carousel__item h3 {*/
/*color: #475669;*/
/*font-size: 14px;*/
/*opacity: 0.75;*/
/*line-height: 150px;*/
/*margin: 0;*/
/*}*/

/*.el-carousel__item:nth-child(2n) {*/
/*background-color: #99a9bf;*/
/*}*/

/*.el-carousel__item:nth-child(2n+1) {*/
/*background-color: #d3dce6;*/
/*}*/
</style>